import { render, staticRenderFns } from "./GetUsersXLS.vue?vue&type=template&id=6963967f"
import script from "./GetUsersXLS.vue?vue&type=script&lang=js"
export * from "./GetUsersXLS.vue?vue&type=script&lang=js"
import style0 from "./GetUsersXLS.vue?vue&type=style&index=0&id=6963967f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports